export default __webpack_public_path__ + "img/4bb169c5c0a01823246ec7746651e9bf.png";